import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shared/components/ui/tabs';
import { WorkspaceOverviewTab } from '../components/WorkspaceOverviewTab';
import { WorkspaceUsersTab } from '../components/WorkspaceUsersTab';
import { WorkspaceApiTokensTab } from '../components/WorkspaceApiTokensTab';
import { WorkspaceDangerZone } from '../components/WorkspaceDangerZone';
import { WorkspaceAuthorizedAppsTab } from '../components/WorkspaceAuthorizedAppsTab';
import { useIsAdmin } from '@/shared/hooks/use-admin-validation';

export function WorkspaceConfigPage() {
  const { t } = useTranslation();
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const { isAdmin } = useIsAdmin();

  if (!workspaceId) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <p className="text-muted-foreground">{t('workspaces.configPage.notFound')}</p>
      </div>
    );
  }

  return (
    <div className="container max-w-[58rem] animate-fade-in">
      <Tabs defaultValue="overview" className="space-y-4">
        <TabsList>
          <TabsTrigger value="overview">{t('workspaces.configPage.tabs.overview')}</TabsTrigger>
          {isAdmin && <TabsTrigger value="users">{t('workspaces.configPage.tabs.users')}</TabsTrigger>}
          <TabsTrigger value="apiTokens">{t('workspaces.configPage.tabs.apiTokens')}</TabsTrigger>
          <TabsTrigger value="authorizedApps">{t('workspaces.configPage.tabs.authorizedApps')}</TabsTrigger>
          {isAdmin && <TabsTrigger value="security">{t('workspaces.configPage.tabs.security', 'Segurança')}</TabsTrigger>}
        </TabsList>

        <TabsContent value="overview">
          <WorkspaceOverviewTab workspaceId={workspaceId} />
        </TabsContent>

        {isAdmin && (
          <TabsContent value="users">
            <WorkspaceUsersTab workspaceId={workspaceId} />
          </TabsContent>
        )}

        <TabsContent value="apiTokens">
          <WorkspaceApiTokensTab workspaceId={workspaceId} />
        </TabsContent>

        <TabsContent value="authorizedApps">
          <WorkspaceAuthorizedAppsTab workspaceId={workspaceId} />
        </TabsContent>

        {isAdmin && (
          <TabsContent value="security">
            <WorkspaceDangerZone workspaceId={workspaceId} />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}
